import { ButtonProps } from "antd";
import { Button } from "../Button/AntButton";


const t = {
  save: "Save",
  cancel: "Cancel",
};

export interface SaveButtonProps extends ButtonProps {
  text?: string;
}
export interface CancelButtonProps extends ButtonProps {
  text?: string;
}



function SaveButton(props: SaveButtonProps) {
  const { text = t.save } = props;
  return (
    <Button type="primary" {...props}>
      {text}
    </Button>
  );
}

function CancelButton(props: CancelButtonProps) {
  return (
    <Button type="text" {...props}>
      {t.cancel}
    </Button>
  );
}

export { SaveButton, CancelButton };
